import type { Reducer } from 'redux';
import type { InfoModalActions } from './types/actions.types';
import InfoModalRecord from './data/InfoModalRecord';
import InfoModalContainerConstants from './constants';

function getInitialState() {
  return new InfoModalRecord();
}

const defaultState = getInitialState();

const reducer: Reducer<InfoModalRecord, InfoModalActions> = (state = defaultState, action) => {
  switch (action.type) {
    case InfoModalContainerConstants.OPEN_INFO_MODAL:
      return state.merge({
        isInfoModalOpen: true,
        langKey: action.langKey,
        langKeyHeader: action.langKeyHeader,
        closeButtonLangKey: action.closeButtonLangKey,
        onAfterClose: action.onAfterClose,
      });

    case InfoModalContainerConstants.CLOSE_INFO_MODAL:
      return getInitialState();

    default:
      return state;
  }
};

export default reducer;
